
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { queryMarkLetter } from "@/api/purchase-order";

@Component({
  name: "updateMark",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "编辑唛头" }) private title: string;
  @Prop({ default: "" }) private customerId: any;
  @Prop({ default: () => [] }) private selectedMark: string[];

  private marks: Mark[] = [];
  private timeout = null;

  @Watch("show", { immediate: true })
  private watchData() {
    if (this.show) {
      this.getList();
    }
  }

  private close() {
    this.$emit("update:show", false);
  }

  private submit() {
    const existBlank = this.marks.some(
      (item) => !item.value || item.value.trim() === ""
    );
    if (existBlank) {
      this.$message.error("不允许有空的唛头，请检查");
      return;
    }
    const valuesSet = new Set<string>();
    for (const mark of this.marks) {
      if (valuesSet.has(mark.value)) {
        this.$message.error("存在重复唛头，请检查");
        return;
      }
      valuesSet.add(mark.value);
    }
    this.$emit("success", this.marks);
    this.$emit("update:show", false);
  }

  private insertRow() {
    this.marks.forEach((item) => (item.edit = false));
    this.marks.push(new Mark("", true));
  }

  async querySearch(queryString, cb) {
    const data: any = await queryMarkLetter([], this.customerId);
    const restaurants = [];
    this.filterNoSelectData(data, restaurants);
    const results = queryString
      ? restaurants.filter(this.createFilter(queryString))
      : restaurants;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      cb(results);
    }, 200);
  }

  private filterNoSelectData(data: any, restaurants: any[]) {
    if (data && this.marks) {
      data.forEach((item) => {
        const selected = this.marks.some((item1) => item1.value === item);
        if (!selected) {
          restaurants.push(new Mark(item, false));
        }
      });
    }
  }

  createFilter(queryString) {
    return (restaurant) => {
      return (
        restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      );
    };
  }

  private deleteRow(index: number) {
    this.marks.splice(index, 1);
  }

  private async getList() {
    this.marks = (this.selectedMark || []).map((item) => new Mark(item, false));
  }

  private edit(row: Mark) {
    if (row.edit) {
      const rowIndex = this.marks.indexOf(row);
      this.marks.splice(rowIndex, 1, { ...row, edit: false });
    } else {
      this.marks.forEach((item) => {
        item.edit = false;
      });
      const rowIndex = this.marks.indexOf(row);
      this.marks.splice(rowIndex, 1, { ...row, edit: true });
    }
  }

  private canEdit(row: Mark): boolean {
    const some = (this.selectedMark || []).some((item) => item === row.value);
    return !some || row.edit;
  }
}

export class Mark {
  value: string;
  edit: boolean;

  constructor(value: string, edit: boolean) {
    this.value = value;
    this.edit = edit;
  }
}
